import * as Realm from 'realm-web';

export interface UserProfile {
  id: string;
  email?: string;
  // Add other relevant user properties from Nexus/Realm as needed
  [key: string]: any;
}

export interface AuthState {
  user: UserProfile | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  error: string | null; // Changed from string | false to string | null for consistency
  loading: boolean;
}

const state: AuthState = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  error: null,
  loading: false
};

export default state;
